import { render, staticRenderFns } from "./AutoLimitIcon.vue?vue&type=template&id=8c603ae6&scoped=true"
import script from "./AutoLimitIcon.vue?vue&type=script&lang=js"
export * from "./AutoLimitIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c603ae6",
  null
  
)

export default component.exports